//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
var now = moment();
export default {
    props: ['resident'],
    data: function data() {
        return {
            balance: 0,
            prepaid: 0,
            occupants: 0,
            hideLease: 1, // process.env.MIX_APP_SHOW_DEV,
            showRenewLease: true,
            openRequest: 0,
            charges: [],
            transAmount: 0,
            transactions: [],
            needsAttentionMessages: [],
            editLeases: false,
            isBlacklisted: false,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '$',
                suffix: '',
                precision: 2,
                masked: false
            },
            unitLeases: [],
            residentDates: {},
            residentLease: false,
            residentLeases: [],
            moveOutLease: {},
            loadingEditor: true,
            loadingBalance: true
        };
    },
    created: function created() {
        Event.$on('refresh-resident-dashboard', this.refreshResidentDashboard);
        Event.$on('violations-updated', this.refresh);
        Event.$on('update-resident-security-deposit', this.updateResidentSecurityDeposit);
        Event.$on('check-blacklist', this.checkBlacklist);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('refresh-resident-dashboard');
        Event.$off('violations-updated');
        Event.$off('update-resident-security-deposit');
        Event.$off('check-blacklist');
    },
    mounted: function mounted() {},

    methods: {
        refreshResidentDashboard: function refreshResidentDashboard() {
            Object.assign(this.$data, this.$options.data());
            this.refresh();
        },
        updateResidentSecurityDeposit: function updateResidentSecurityDeposit(val) {
            this.resident.unit.unit_lease.resident_deposit_amount = val;
        },
        cancelMoveOut: function cancelMoveOut(value) {
            var _this = this;

            window.axios.post('/prototype/residents/cancel-move-out', value).then(function (response) {
                if (response.data.error) {
                    _this.$snotify.error('Error cancelling move out: ' + response.data.error);
                } else {
                    _this.$snotify.success("The resident move-out was cancelled");
                    Event.$emit('close-small-modal');
                    Event.$emit('resident-list-dashboard-updated');
                    Event.$emit('refresh-resident-dashboard');
                }
            });
        },
        dateFilter: function dateFilter(value) {
            if (moment(value).isValid()) return moment(value).format('MM/DD/YYYY');
        },
        sendPortalInvite: function sendPortalInvite() {

            var $el = this;

            var sendData = {
                id: $el.resident.id
            };

            window.axios.post('/prototype/person/resident/portal-invite', sendData).then(function (response) {
                if (response.data == 'no email') {
                    $el.$snotify.error('This resident does not have an associated email address.');
                } else {
                    $el.$snotify.success('Invite sent');
                }
            });
        },
        addViolation: function addViolation() {
            Event.$emit('resident-add-violation');
        },
        confirmInvitation: function confirmInvitation() {
            Event.$emit('resident-confirm-portal-invite');
        },
        confirmBlacklist: function confirmBlacklist() {
            Event.$emit('resident-confirm-blacklist');
        },
        checkBlacklist: function checkBlacklist() {
            var self = this;

            var sendData = {
                resident: self.resident.id
            };

            window.axios.post('/prototype/person/resident/check-blacklist', sendData).then(function (response) {
                self.isBlacklisted = response.data && Object.entries(response.data).length > 0 ? true : false;
            });
        },
        transferUnit: function transferUnit() {
            Event.$emit('resident-transfer-unit', this.resident);
        },
        renewLease: function renewLease() {
            Event.$emit('resident-renew-lease', this.resident);
        },
        residentAddPayment: function residentAddPayment() {
            Event.$emit('resident-add-payment');
        },
        sendNotification: function sendNotification() {
            Event.$emit('new-notification');
        },
        addTransaction: function addTransaction() {
            Event.$emit('show-gl-wizard', this.resident);
        },
        showLeaseTab: function showLeaseTab() {
            Event.$emit('manually-select-tab', this.$parent.$parent.$children[7]);
        },
        editLeaseData: function editLeaseData() {
            this.editLeases = true;
        },
        saveLeaseData: function saveLeaseData() {
            var _this2 = this;

            var $el = this;
            // create save object
            var residentData = $el.resident;
            axios.post('/prototype/person/resident/lease-data', residentData).then(function (response) {
                if (response.data.error) {
                    _this2.$snotify.error('Error saving Lease data: ' + response.data.error);
                } else {
                    _this2.$snotify.success('Lease data was updated');
                    _this2.editLeases = false;
                    _this2.refresh();
                    Event.$emit('resident-list-dashboard-updated');
                }
            });
        },
        refresh: function refresh() {
            var _this3 = this;

            var $el = this;
            $el.loadingEditor = true;
            axios.get('/prototype/resident/' + $el.resident.id).then(function (response) {
                if (response.data) {
                    $el.moveOutLease = response.data;
                    console.log('set resident moveOutLease = ');
                    console.log($el.moveOutLease);
                    //$el.resident = response.data // why was it changed to $residentById??
                    var residentData = $el.resident;
                    // fix dates
                    // NOTE: Resident has carbon $dates, UnitLease does not - dateFilter() should fix this for vue
                    if (response.data.lease_start_date) {
                        $el.residentDates.lease_start_date = $el.dateFilter(response.data.lease_start_date);
                    }
                    if (response.data.move_in_date) {
                        $el.residentDates.move_in_date = $el.dateFilter(response.data.move_in_date);
                    }
                    if (response.data.move_out_date) {
                        $el.residentDates.move_out_date = $el.dateFilter(response.data.move_out_date);
                    }
                    if (response.data.lease_expire_date) {
                        $el.residentDates.lease_expire_date = $el.dateFilter(response.data.lease_expire_date);
                    }

                    if (response.data.leases.length) {
                        var residentLeases = response.data.leases;
                        $el.residentLeases = residentLeases;

                        for (var i = 0; i < residentLeases.length; i++) {
                            if (residentLeases[i].lease_start_date) {
                                $el.residentLeases[i].lease_start_date = $el.dateFilter(residentLeases[i].lease_start_date);
                            }
                            if (residentLeases[i].move_in_date) {
                                $el.residentLeases[i].move_in_date = $el.dateFilter(residentLeases[i].move_in_date);
                            }
                            if (residentLeases[i].termination_date) {
                                $el.residentLeases[i].move_out_date = $el.dateFilter(residentLeases[i].termination_date);
                            }
                            if (residentLeases[i].lease_expiration_date) {
                                $el.residentLeases[i].lease_expiration_date = $el.dateFilter(residentLeases[i].lease_expiration_date);
                            }
                            if (residentLeases[i].is_active == 1) {
                                $el.resident.lease = residentLeases[i];
                                $el.residentLease = residentLeases[i];
                            }
                        }

                        $el.resident.leases = residentLeases;
                        $el.resident.has_renewal_lease = response.data.has_renewal_lease;
                        $el.resident.has_transfer_lease = response.data.has_transfer_lease;
                    }

                    $el.checkBlacklist();
                }
                $el.loadingEditor = false;
            });

            this.needsAttentionMessages = [];
            axios.post('/prototype/resident/ledger/prepaid', { id: $el.resident.id }).then(function (response) {
                return _this3.prepaid = response.data;
            });
            axios.post('/prototype/resident/ledger/balance', { id: $el.resident.id }).then(function (response) {
                return _this3.balance = response.data;
            });

            axios.post('/prototype/resident/ledger/balance', { id: $el.resident.id }).then(function (response) {
                _this3.loadingBalance = true;
                _this3.balance = response.data;
                _this3.loadingBalance = false;
            });

            axios.post('/prototype/resident/ledger/recurring', { id: $el.resident.id }).then(function (response) {
                return _this3.charges = response.data;
            });
            axios.post('/prototype/person/residents/associated-occupants', { id: $el.resident.id }).then(function (response) {
                return _this3.occupants = response.data.length;
            });

            axios.post('/prototype/person/residents/get-lease-information', { residentId: $el.resident.id }).then(function (response) {
                if (response.data) {
                    if (response.data.lease_expiration_days_remaining && response.data.lease_expiration_days_remaining < 60) {
                        _this3.needsAttentionMessages.push('Lease is expiring in under 60 days.');
                    }
                }
            });
            axios.post('/prototype/resident/ledger', { id: $el.resident.id }).then(function (response) {
                if (response.data) {
                    var pastDueCount = 0;
                    $el.transactions = response.data.transactions;
                    var transactions = response.data.transactions;
                    transactions.forEach(function (transaction) {
                        var pastDue = moment(transaction.due_at).diff(moment()) <= 0 ? true : false;
                        if (pastDue) {
                            pastDueCount = pastDueCount + 1;
                        }
                    });
                    if (pastDueCount > 0) {
                        _this3.needsAttentionMessages.push('Account has ' + pastDueCount + ' past due transactions.');
                    }
                }
            });
            if ($el.resident) {
                axios.get('/prototype/residents/' + $el.resident.id + '/serviceRequests').then(function (response) {
                    if (response.data) {
                        var payLoad = [];
                        var payLoadClosed = [];
                        response.data.forEach(function (element) {
                            if (element.completed_at) {
                                payLoadClosed.push(element);
                            } else {
                                payLoad.push(element);
                            }
                        });
                        $el.openRequest = payLoad.length;
                    }
                });
                Event.$emit('refresh-resident-recurring-transactions');
            }
        },
        sendBalanceNotification: function sendBalanceNotification() {
            var $el = this;

            this.transactions.filter(function (t) {
                var due = moment(t.due_at, 'YYYY-MM-DD');

                return now.valueOf() < due.valueOf() && due.diff(now, 'days') <= 5;
            }).forEach(function (t, index) {
                $el.transAmount += t.amount;
            });

            //
            axios.post('/prototype/resident/ledger/notify', {
                resident: $el.resident.id,
                transaction: $el.transAmount
            }).then(function (response) {
                $el.$snotify.success('The notification is queued to send');
            });
        },
        moveOut: function moveOut(item) {
            Event.$emit('move-out', item);
        },
        undoLeaseRenewal: function undoLeaseRenewal() {
            var _this4 = this;

            var $el = this;
            axios.post('/prototype/person/resident/undo-renewal-lease', { resident_id: $el.resident.id }).then(function (response) {
                if (response.data.error) {
                    _this4.$snotify.error('Error removing renewal lease: ' + response.data.error);
                } else {
                    _this4.$snotify.success('The renewal lease has been removed');
                    Event.$emit('resident-list-dashboard-updated');
                    Event.$emit('refresh-resident-dashboard', $el.resident);
                }
            });
        },
        undoTransferUnit: function undoTransferUnit() {
            var _this5 = this;

            var $el = this;
            axios.post('/prototype/person/resident/undo-transfer-unit', { resident_id: $el.resident.id }).then(function (response) {
                if (response.data.error) {
                    _this5.$snotify.error('Error removing transfer lease: ' + response.data.error);
                } else {
                    _this5.$snotify.success('Unit transfer successfully undone. The transfer lease has been removed');
                    Event.$emit('resident-list-dashboard-updated');
                    Event.$emit('refresh-resident-dashboard', $el.resident);
                }
            });
        }
    },
    computed: {
        isAdmin: function isAdmin() {
            return window.user.role == 'super-admin' || window.user.role == 'corporate-admin';
        },
        canEditLease: function canEditLease() {
            return window.user.can['update-all'] || window.user.can['update-lease'];
        },
        totalRecurringCharges: function totalRecurringCharges() {
            return Number.parseFloat(this.charges.reduce(function (prev, cur) {
                return prev + Number.parseFloat(cur.amount);
            }, 0)).toFixed(2);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentDetailsDashboard.vue
// module id = k87m
// module chunks = 0 1